import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CountryModel, CountryService } from '@railmybox/api-booking';
import { Country } from '../phone-number.interface';
import { Observable, of } from 'rxjs';
import { delay, map, switchMap } from 'rxjs/operators';
import { TranslocoService } from '@jsverse/transloco';
import { SelectItem, TranslateSelectItemsService } from '@eg/ui';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable()
export class CountryCodeService {
  private httpClient = inject(HttpClient);
  private countryService = inject(CountryService);
  private translocoService = inject(TranslocoService);
  private translateSelectItemsService = inject(TranslateSelectItemsService);

  getCountryList(): Observable<Country[]> {
    return this.countryService.getCountries().pipe(
      map((countries: CountryModel[]) => {
        return countries
          .filter((country) => country.callingCodes[0])
          .map(
            (country) =>
              ({
                ...country,
                alpha2Code: country.id,
                translatedName: country.display,
              }) as Country
          );
      })
    );
  }

  getCountrySelectItems(): Observable<SelectItem[]> {
    return this.translocoService.langChanges$.pipe(
      untilDestroyed(this),
      delay(500),
      switchMap(() => {
        return this.getCountryList();
      }),
      map((countries) => {
        return countries.map((country) => ({
          label: country.name,
          value: country.alpha2Code,
        }));
      }),
      switchMap((countries) => {
        const selectedItems = this.translateSelectItemsService.getCountryListTranslated(countries);
        return of(selectedItems);
      })
    );
  }
}
